import type { FieldIndentifier } from "@packages/lib";
import { dexie } from "./db";
import type { Configs } from "./store";

export async function loadConfigsFromDexie() {
  const [uiFields, columnsInDB, options] = await Promise.all([
    dexie.uiFields.toArray(),
    dexie.columnsInDB.toArray(),
    dexie.options.toArray(),
  ]);

  const optionsByGroup = options.reduce(
    (acc, option) => {
      if (!acc[option.optionGroupId]) {
        acc[option.optionGroupId] = [];
      }
      acc[option.optionGroupId].push({
        value: option.id,
        label: option.labelSv || option.labelEn || option.id,
        disabled: !option.isActive,
      });
      return acc;
    },
    {} as Record<string, { value: string; label: string; disabled: boolean }[]>,
  );

  const configs: Configs = {};

  columnsInDB.forEach((col) => {
    const { schemaName, tableName, fieldName } = col;
    if (!configs[schemaName]) {
      configs[schemaName] = {};
    }
    if (!configs[schemaName][tableName]) {
      configs[schemaName][tableName] = {};
    }
    configs[schemaName][tableName][fieldName] = {
      fieldIdentifier: `${schemaName}.${tableName}.${fieldName}` as FieldIndentifier,
      columnType: col.dataType,
      isNullable: col.isNullable,
      isEditable: col.isEditable,
      label: fieldName,
      customType: null,
    };
  });

  uiFields.forEach((uiField) => {
    const { schemaName, tableName, fieldName } = uiField;
    if (configs[schemaName]?.[tableName]?.[fieldName]) {
      configs[schemaName][tableName][fieldName] = {
        ...configs[schemaName][tableName][fieldName],
        label: uiField.labelSv || uiField.labelEn || fieldName,
        customType: uiField.customType,
        options: uiField.optionGroupId ? optionsByGroup[uiField.optionGroupId] || [] : undefined,
      };
    }
  });

  return configs;
}
